export default [
  {
    headerName: '',
    width: 30,
    field: 'rowIndex',
    hidden: true,
    suppressMovable: true,
    cellStyle: {
      textAlign: 'center',
      padding: '5px 0',
      color: '#595959',
      backgroundColor: '#f0f0f0',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '500',
      boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
    },
  },
  {
    headerName: '经销商名称',
    field: 'orgName',
    width: 20,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '销售代码',
    field: 'preSalesNumber',
  },
  {
    headerName: '售后代码',
    field: 'afterSalesNumber'
  },
  {
    headerName: '品牌',
    field: 'brandName'
  }
]